var render, staticRenderFns
import script from "./-MyHotelLocation.tsx?vue&type=script&lang=js&"
export * from "./-MyHotelLocation.tsx?vue&type=script&lang=js&"
import style0 from "./MyHotelLocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports